export const CURRENCY_MAPPING = {
  INR: '₹',
  USD: '$',
};
